module.exports = __webpack_public_path__ + "static/media/morralla.311c0a1a.png";